import { z } from "zod";
import { createZodDto } from "nestjs-zod/dto";

const linkedInJobSearchSchema = z.object({
  keyword: z.string().optional(),
  location: z.string().optional(),
  dateSincePosted: z.enum(["past month", "past week", "24hr"]).optional(),
  jobType: z
    .enum([
      "full time",
      "full-time",
      "part time",
      "part-time",
      "contract",
      "temporary",
      "volunteer",
      "internship",
    ])
    .optional(),
  remoteFilter: z.enum(["on-site", "on site", "remote", "hybrid"]).optional(),
  salary: z.enum(["40000", "60000", "80000", "100000", "120000"]).optional(),
  experienceLevel: z
    .enum(["internship", "entry level", "associate", "senior", "director", "executive"])
    .optional(),
  sortBy: z.enum(["recent", "relevant"]).optional(),
  limit: z.string().optional(),
  page: z.string().optional(),
});

export class LinkedInJobSearchDto extends createZodDto(linkedInJobSearchSchema) {}
